import * as UI from "@iyk/ui"

export const PointsHeading = ({ children, className, ...props }: React.ComponentProps<"div">) => (
  <div className={UI.cx("flex items-center gap-2 flex-1", className)} {...props}>
    <UI.Icon.Points className="bg-points" />
    <span className={classForHeading}>{children}</span>
  </div>
)

export const classForHeading = UI.cx(["text-[11px] leading-[14px] font-departure-mono uppercase"])
